import {
  createFileRoute,
  linkOptions,
  redirect,
} from '@tanstack/react-router';

const settingsRequestLinkOptions = linkOptions({
  to: '/mydigitalworkers/omni/settings/ssid',
  from: '/mydigitalworkers/omni/settings/',
});
export const Route = createFileRoute(
  '/_app/_authenticated/mydigitalworkers/omni/_omniLayout/settings/',
)({
  beforeLoad: () => {
    throw redirect(settingsRequestLinkOptions);
  },
  component: RouteComponent,
});
function RouteComponent() {
  return (<></>);
}
